module.exports = __webpack_public_path__ + "static/media/fechar.d3fe265d.svg";